export const isPageSlug = (slug: string): boolean =>
  !/(\.js|\.json|\.ico|\.css|static\/)/.test(slug)
